import { blue02 } from '../../../colors/blue';
export var MuiToggleButtonGroup = {
    styleOverrides: {
        groupedHorizontal: {
            '&[class*=Mui-selected]:not(:first-of-type)': {
                borderLeftColor: blue02,
            },
            '&:active:not(:first-of-type)': {
                borderLeftColor: blue02,
            },
            '&:active:not(:last-child)': {
                borderRightColor: blue02,
            },
        },
    },
};
